import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginAccess.css';

function LoginAccess() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    const demoUser = 'distribuiPRO';
    const demoPass = 'a1';

    if (username === demoUser && password === demoPass) {
      localStorage.setItem('appAccess', 'true');
      navigate('/app');
    } else {
      setError('Usuario o contraseña incorrectos');
    }
  };

  return (
    <div className="login-access-page">
      <div className="login-access-card">
        <span className="login-kicker">Acceso clientes</span>
        <h1>Ingresá a tus soluciones</h1>
        <p>
          Ingresá tus credenciales para acceder a demos, plataformas y descargas disponibles.
        </p>

        <form onSubmit={handleSubmit} className="login-access-form">
          <input
            type="text"
            placeholder="Usuario"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {error && <div className="login-error">{error}</div>}

          <button type="submit">Ingresar</button>
        </form>
      </div>
    </div>
  );
}

export default LoginAccess;